import {v1 as uuidv1} from 'uuid';
import isEmpty from 'lodash/isEmpty';
import {CONTENT_SUGGESTION, CONTACT_OPTIONS, CAAS_CONTENT} from '../app.config';
import {
  UPDATE_UH_COMPONENT_SHOWING_NOW,
  UPDATE_HEADER_RELOAD_AND_BACK,
  UPDATE_CONTENT_SUGG_USER_INPUT,
  TOGGLE_USER_INPUT,
  TOGGLE_MAIN_WINDOW_AND_FAB,
  UPDATE_SKILLS_RESPONSE,
  UPDATE_EXCEPTION_MSG,
  TOGGLE_AVA_LOADING,
  SHOW_AVA_MODAL,
  CLOSE_AVA_MODAL,
  UPDATE_SELECTED_PRODUCT,
  UPDATE_SELECTED_VERSION,
  UPDATE_SHOW_PRODUCT_PICKER,
  DISABLE_NAVBAR,
  SHOW_FAIL_SCREEN,
  TOGGLE_POP_UP_MAIN_WINDOW,
  OPEN_UHM_THROUGH_LINK,
  UPDATE_CONTEXTUAL_LINK_ORIGIN,
  UPDATE_LINK_LOCATION,
  UPDATE_CONTACT_APP_LOADING,
  QUICK_TOGGLE_SHOW_PHONE_FOOTER,
  UPDATE_CONTENT_SUGG_LOADING,
  SHOW_FEEDBACK_WIDGET_FLOW,
  FEEDBACK_WIDGET_MOUNTED,
  HIDE_SECONDARY_NAV,
  SHOW_CONFIRM_MODAL,
  SHOW_ADDITIONAL_QUESTIONS,
  UPDATE_UI_DATA,
  RESET_UI_STATES,
  RESET_TO_HOME,
  CONTAINER_EVENT_MESSAGE,
  UPDATE_FAB_HEADER_COLORS,
  UPDATE_IS_CHAT_ACTIVE,
  IS_END_CHAT_THROUGH_BUTTON,
  UPDATE_UHM_SUB_HEADER_TYPE,
  UPDATE_SAVE_CHAT_TRIGGER,
  UPDATE_END_CHAT_TRIGGER,
  UPDATE_SHOW_OVERLAY_COMPONENT,
  HAS_INTRUCTIONAL_TEXT,
  UPDATE_USER_INPUT_FROM_AVA,
  ANYTHING_ELSE_END_CHAT,
  // SHOW_AGENT_AVAILABILITY_COMPONENT,
  SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT,
  SHOW_ANYTHING_ELSE_COMPONENT,
  SHOW_PHONE_HOUR_BUBBLE_COMPONENT,
  DEEPLINK_CA_EDU_FLOW,
  UPDATE_USER_INTERACTION,
  UPDATE_OPEN_AFTER_REDIRECT,
  UPDATE_REQUEST_ID,
} from '../actions/types';

const initialState = {
  componentShowingInUH: 'DISAMBIGUATION_QUESTIONS',
  showReloadAndBack: false,
  contentSuggestionInput: '',
  showForm: true,
  showMainWindow: false,
  hasUserInteracted: false,
  skillsResponse: {},
  exceptionMsg: '',
  contentSuggLoading: false,
  avaLoading: false,
  showAvaConfirmModal: false,
  avaConfirmAction: 'RESTART', //RESTART || BACK
  selectedProduct: null,
  selectedVersion: null,
  componentData: {},
  lastComponentShown: '',
  lastComponentData: {},
  contentSuggestionFlowRef: {}, //Tracks data for CS>PBS>ContactApp flow
  showProductPicker: false,
  showTextfield: false,
  requestId: null,
  disableNavbar: false,
  fail: false,
  popUpMainWindow: false,
  contactAppLoading: true,
  toggleShowPhoneFooter: true,
  showFeedbackWidgetFlow: false,
  isFeedbackWidgetMounted: false,
  hideSecondaryNav: false,
  contactModalityShowing: '',
  showConfirmModal: false,
  goToAfterConfirm: '', // HOME|GUID
  openUHMThroughLink: false,
  showAdditionalQuestionsPage: true,
  contextualLinkOrigin: '',
  linkLocation: '',
  isInProductUiFlow: false,
  resetToHome: false,
  containerEventMessage: '',
  colorsToUpdate: {},
  isChatActive: false,
  isEndChatThroughButton: false,
  uhmSubHeaderType: 'AVA',
  saveChatTrigger: 0,
  endChatTrigger: false,
  showOverlayComponent: false,
  hasInstructionalText: false,
  userInputFromAva: '',
  isAnythingElseEndChat: false,
  showAgentAvailabilityComponent: false,
  showAgentAvailabilityFallbackComponent: false,
  showAnythingElseComponent: false,
  showPhoneHourBubbleComponent: false,
  deeplinkContactAppEduFlow: false,
  confirmModalType: '',
  openAfterRedirect: false,
};

const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_UI_DATA:
      // won't be called when integrationType is undefined
      const {integrationType} = action.payload;
      //use for showing/hiding back btn when app in in-product flow
      const isInProductUiFlow = integrationType === 'In-Product';

      return {
        ...state,
        isInProductUiFlow,
      };
    case UPDATE_UH_COMPONENT_SHOWING_NOW:
      const {componentShowingInUH, componentData} = state;
      const otherState =
        componentData && componentData.showProductPicker !== undefined
          ? {showProductPicker: componentData.showProductPicker}
          : {};
      let currRequestId = state.requestId;

      if (
        (action.payload.id === CONTACT_OPTIONS ||
          action.payload.id === CAAS_CONTENT) &&
        state.isInProductUiFlow
      ) {
        otherState.showReloadAndBack = true;
      }

      //keeps track of CS input box data in UHM app
      if (
        action.payload.id === CAAS_CONTENT &&
        componentShowingInUH === CONTENT_SUGGESTION
      ) {
        otherState.contentSuggestionFlowRef = {...componentData};
      }
      
      if (action.payload.id === CONTENT_SUGGESTION) {

        if (!isEmpty(state.contentSuggestionFlowRef)) {
          // Clears flow CS > PBC > Contact App data
          otherState.contentSuggestionFlowRef = {};
        }

        if (state.isInProductUiFlow) {
          otherState.showReloadAndBack = false;
        }
      }

      return {
        ...state,
        lastComponentShown: componentShowingInUH,

        lastComponentData: {...componentData},
        componentShowingInUH: action.payload.id,
        componentData: action.payload.actionData,
        requestId: currRequestId,
        ...otherState,
      };
    case UPDATE_HEADER_RELOAD_AND_BACK:
      return {...state, showReloadAndBack: action.payload};
    case HIDE_SECONDARY_NAV:
      return {
        ...state,
        hideSecondaryNav: action.payload.isHide,
        contactModalityShowing: action.payload.modalityShowing,
      };
    case SHOW_CONFIRM_MODAL:
      return {
        ...state,
        showConfirmModal: action.payload.isShow,
        goToAfterConfirm: action.payload.goToAfterConfirm,
        confirmModalType: action.payload.confirmModalType,
      };
    case UPDATE_CONTENT_SUGG_USER_INPUT:
      return {...state, contentSuggestionInput: action.payload};
    case TOGGLE_USER_INPUT:
      if (action.payload.newReqId) {
        return {
          ...state,
          showForm: action.payload.showOrHide,
          requestId: action.payload.newReqId,
        };
      } else {
        return {...state, showForm: action.payload.showOrHide};
      }
    case TOGGLE_MAIN_WINDOW_AND_FAB:
      return {...state, showMainWindow: action.payload};
    case UPDATE_SKILLS_RESPONSE:
      return {...state, skillsResponse: action.payload};
    case UPDATE_EXCEPTION_MSG:
      return {...state, exceptionMsg: action.payload};
    case TOGGLE_AVA_LOADING:
      return {...state, showAvaConfirmModal: false, avaLoading: action.payload};
    case SHOW_AVA_MODAL:
      return {
        ...state,
        showAvaConfirmModal: true,
        avaConfirmAction: action.payload || 'RESTART',
      };
    case CLOSE_AVA_MODAL:
      return {
        ...state,
        showAvaConfirmModal: false,
      };
    case UPDATE_SELECTED_PRODUCT:
      return {...state, selectedProduct: action.payload};
    case UPDATE_SELECTED_VERSION:
      return {...state, selectedVersion: action.payload};
    case UPDATE_SHOW_PRODUCT_PICKER:
      return {...state, showProductPicker: action.payload};
    case DISABLE_NAVBAR:
      return {...state, disableNavbar: action.payload};
    case SHOW_FAIL_SCREEN:
      return {...state, fail: action.payload};
    case TOGGLE_POP_UP_MAIN_WINDOW:
      return {...state, popUpMainWindow: action.payload};
    case OPEN_UHM_THROUGH_LINK:
      return {...state, openUHMThroughLink: action.payload};
    case UPDATE_CONTEXTUAL_LINK_ORIGIN:
      return {...state, contextualLinkOrigin: action.payload};
    case UPDATE_LINK_LOCATION:
      return {...state, linkLocation: action.payload};
    case UPDATE_CONTACT_APP_LOADING:
      return {
        ...state,
        contactAppLoading: action.payload,
        hideSecondaryNav: false,
      };
    case QUICK_TOGGLE_SHOW_PHONE_FOOTER:
      return {...state, toggleShowPhoneFooter: action.payload};
    case UPDATE_CONTENT_SUGG_LOADING:
      return {...state, contentSuggLoading: action.payload};
    case SHOW_FEEDBACK_WIDGET_FLOW:
      return {...state, showFeedbackWidgetFlow: action.payload};
    case FEEDBACK_WIDGET_MOUNTED:
      return {...state, isFeedbackWidgetMounted: action.payload};
    case SHOW_ADDITIONAL_QUESTIONS:
      return {...state, showAdditionalQuestionsPage: action.payload};
    case RESET_TO_HOME:
      return {...state, resetToHome: action.payload};
    case CONTAINER_EVENT_MESSAGE:
      return {...state, containerEventMessage: action.payload};
    case UPDATE_FAB_HEADER_COLORS:
      return {
        ...state,
        colorsToUpdate: action.payload,
      };
    case UPDATE_IS_CHAT_ACTIVE:
      return {...state, isChatActive: action.payload};
    case IS_END_CHAT_THROUGH_BUTTON:
      return {...state, isEndChatThroughButton: action.payload};
    case HAS_INTRUCTIONAL_TEXT:
      return {
        ...state,
        hasInstructionalText: action.payload,
      };
    case RESET_UI_STATES:
      return {
        ...state,
        contentSuggestionInput: '',
        selectedProduct: null,
        selectedVersion: null,
        exceptionMsg: '',
        skillsResponse: {},
        showForm: true,
        showAvaConfirmModal: false,
        hideSecondaryNav: false,
        contactModalityShowing: '',
        showAdditionalQuestionsPage: true,
        containerEventMessage: '',
      };
    case UPDATE_UHM_SUB_HEADER_TYPE:
      return {...state, uhmSubHeaderType: action.payload};
    case UPDATE_SAVE_CHAT_TRIGGER:
      const newValue = action.payload === 0 ? 0 : state.saveChatTrigger + 1;
      return {...state, saveChatTrigger: newValue};
    case UPDATE_END_CHAT_TRIGGER:
      return {...state, endChatTrigger: action.payload};
    case UPDATE_SHOW_OVERLAY_COMPONENT:
      return {...state, showOverlayComponent: action.payload};
    case UPDATE_USER_INPUT_FROM_AVA:
      return {...state, userInputFromAva: action.payload};
    case ANYTHING_ELSE_END_CHAT:
      return {...state, isAnythingElseEndChat: action.payload};
    // case SHOW_AGENT_AVAILABILITY_COMPONENT:
    //   return {...state, showAgentAvailabilityComponent: action.payload};
    case SHOW_AGENT_AVAILABILITY_FALLBACK_COMPONENT:
      return {...state, showAgentAvailabilityFallbackComponent: action.payload};
    case SHOW_ANYTHING_ELSE_COMPONENT:
      return {...state, showAnythingElseComponent: action.payload};
    case SHOW_PHONE_HOUR_BUBBLE_COMPONENT:
      return {...state, showPhoneHourBubbleComponent: action.payload};
    case DEEPLINK_CA_EDU_FLOW:
      return {...state, deeplinkContactAppEduFlow: action.payload};
    case UPDATE_USER_INTERACTION:
      return {...state, hasUserInteracted: action.payload};
    case UPDATE_OPEN_AFTER_REDIRECT:
      return {...state, openAfterRedirect: action.payload};
    case UPDATE_REQUEST_ID:
      return {...state, requestId: action.payload};
    default:
      return state;
  }
};

export default uiReducer;
